import React, { useState } from 'react';

import { Button, Text } from '@betterment/samba-react';

const MaskedAccountNumber: React.FC<React.PropsWithChildren<{ accountNumber: string }>> = ({ accountNumber }) => {
  const [isDataDisplayed, setIsDataDisplayed] = useState(false);

  return (
    <>
      <Text as="span" css={{ mr: 'space.200' }}>
        {isDataDisplayed ? accountNumber : `••••••••${accountNumber.substring(accountNumber.length - 4)}`}
      </Text>
      {!isDataDisplayed && (
        <Button aria-label="Show account number" variant="textPrimary" onClick={() => setIsDataDisplayed(true)}>
          Show
        </Button>
      )}
    </>
  );
};

export default MaskedAccountNumber;
